"use client";

import { StudioBlobLinkField } from "@/app/studio/pages/[slug]/StudioBlobLinkField";

export function studioLinkField(label = "Link") {
  return {
    type: "custom" as const,
    label,
    render: ({
      value,
      onChange,
    }: {
      value: string;
      onChange: (value: string) => void;
    }) => (
      <StudioBlobLinkField
        value={typeof value === "string" ? value : ""}
        onChange={onChange}
      />
    ),
  };
}
